var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKosher = function SvgKosher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__a)",
    stroke: "url(#Kosher_svg__b)",
    strokeMiterlimit: 10,
    strokeWidth: 0.134,
    d: "M8.224 18.958c-.045-6.08 5.03-11.199 11.333-11.11 6.08.09 10.975 5.142 10.93 11.29-.067 6.124-5.118 11.019-11.332 10.974-6.013-.067-10.976-5.118-10.909-11.154zm22.062.023c0-6.058-4.917-10.953-10.997-10.931-6.103 0-10.953 5.007-10.909 11.065.045 5.968 4.985 10.84 11.02 10.819 5.969 0 10.886-4.963 10.864-10.953z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__c)",
    d: "M32.294 20.149H30.84c.246-.425.47-.827.715-1.252-.223-.38-.47-.804-.715-1.252.357-.111 1.252-.067 1.363.067.29-.491.56-.96.872-1.497.268.47.537.916.805 1.386h1.453c-.246.447-.492.85-.716 1.252.224.402.47.827.716 1.274H33.88q-.369.636-.805 1.408c-.268-.47-.536-.917-.805-1.386zm-.514-1.453c.111-.268.223-.537.313-.782-.224 0-.448 0-.716.044q.2.404.403.738c.223.38.447.76.715 1.162h1.23c.156-.268.357-.58.536-.894.022-.067 0-.179-.023-.246-.134-.268-.29-.514-.469-.827h-1.162c-.067 0-.157.067-.201.134-.157.246-.291.492-.425.738-.09-.045-.157-.067-.201-.09zm1.788-1.118c-.157-.245-.29-.491-.47-.76-.156.269-.29.492-.424.76zm-.917 2.593c.157.268.291.492.447.76.157-.268.291-.514.425-.76zm2.191-.335c-.134-.246-.268-.47-.38-.693-.112.246-.224.447-.335.693h.737zm-2.75-.022c-.133-.246-.268-.447-.38-.626-.111.223-.223.425-.335.626h.716m2.728-1.878h-.693c.134.224.246.425.357.626.112-.201.201-.402.336-.626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__d)",
    d: "M8.401 30.72c.783-1.005 1.543-2.011 2.325-3.017.559.447 1.14.872 1.676 1.341.448.38.47.85.18 1.32-.291.446-.76.58-1.275.357-.044 0-.09-.045-.134-.067v2.123c-.447-.156-.559-.313-.536-.693.022-.38.044-.782.067-1.162 0-.38-.112-.67-.447-.894a4 4 0 0 1-.403-.313c-.335.447-.67.872-1.028 1.319-.134-.112-.268-.201-.425-.313m1.7-1.363c.424.29.804.604 1.206.85.336.2.649.111.827-.157.18-.246.134-.559-.156-.805-.358-.312-.738-.58-1.118-.871-.268.335-.492.648-.782 1.006z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__e)",
    d: "M27.736 8.38c-.38.424-.76.826-1.14 1.251a6 6 0 0 1-.38-.357c.872-.94 1.699-1.878 2.57-2.817.537.514 1.096 1.006 1.61 1.542.357.38.313.894 0 1.32-.313.357-.783.446-1.23.223-.067-.023-.134-.067-.156-.067-.067.693-.157 1.386-.224 2.123-.514-.357-.536-.38-.447-.916.067-.38.112-.76.157-1.118.045-.29-.067-.536-.29-.738a8 8 0 0 1-.448-.424zm.268-.314c.38.336.738.671 1.14.962.313.223.648.156.872-.112.201-.246.156-.559-.112-.827-.335-.335-.67-.626-1.028-.961a19 19 0 0 0-.872.938"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__f)",
    d: "M17.995 31.179c.626 0 1.252-.023 1.878 0 .626.044.983.469 1.185 1.028.2.581.178 1.162-.023 1.743-.223.581-.648.917-1.274.962-.514.044-1.028.044-1.542.044-.067 0-.202-.09-.202-.156v-3.644zm.514 3.353c.447 0 .872 0 1.274-.067.447-.068.716-.358.783-.783.044-.335.067-.693.044-1.05-.022-.38-.178-.738-.558-.895-.514-.223-1.051-.111-1.543-.089v2.906z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__g)",
    d: "M16.781 32.185c-.045.96-.604 2.123-1.9 2.123-1.05 0-1.9-.827-1.878-1.855 0-1.14.872-2.101 1.856-2.101 1.095 0 1.922.782 1.922 1.832m-.537.2c.023-.893-.29-1.34-.916-1.52-.603-.178-1.162.023-1.453.604a2.9 2.9 0 0 0-.313.961c-.09.56.201 1.051.693 1.297.559.268 1.095.179 1.498-.246.357-.38.491-.827.514-1.095z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__h)",
    d: "M10.878 6.498c0-.983.827-1.81 1.878-1.81.983 0 1.922 1.005 1.922 2.123 0 .984-.827 1.788-1.855 1.81-1.05 0-1.923-.938-1.945-2.145zm1.967 1.721c.76-.022 1.341-.58 1.319-1.296 0-.648-.29-1.207-.85-1.565-.648-.447-1.676-.045-1.9.715-.2.693.291 1.744.962 2.034.156.068.313.09.469.135z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__i)",
    d: "M24.72 4.273c.849.402 1.676.782 2.525 1.184-.067.157-.134.269-.2.403-.694-.336-1.364-.649-2.057-.984-.157.335-.313.67-.492 1.028.648.313 1.274.626 1.922.94q-.1.2-.2.402c-.649-.291-1.275-.604-1.923-.895-.179.38-.358.738-.559 1.14.715.336 1.408.671 2.124 1.029-.067.134-.112.246-.18.402-.871-.402-1.72-.805-2.615-1.23.537-1.14 1.073-2.28 1.632-3.442z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__j)",
    d: "M18.175 4.336c-.246.089-.447.2-.626-.18-.067-.133-.313-.268-.469-.268-.313 0-.626.068-.916.157-.224.067-.336.268-.313.514.022.246.2.402.447.425.38.044.76.067 1.14.112.626.067.96.312 1.095.804.09.336 0 .626-.201.894-.492.626-1.788.76-2.414.269a1.03 1.03 0 0 1-.403-.76c.246-.09.425-.157.581.178.18.38.693.515 1.207.38.157-.044.313-.089.448-.156.223-.134.357-.335.313-.604-.045-.268-.224-.402-.47-.447-.425-.067-.872-.09-1.296-.156-.582-.09-.872-.38-.917-.872-.045-.447.201-.85.715-1.028a3.5 3.5 0 0 1 1.073-.157c.514 0 .895.403.984.917z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__k)",
    d: "M20.108 5.33c-.09.603-.18 1.185-.269 1.766a5 5 0 0 1-.514-.09c.179-1.251.358-2.48.537-3.733.156 0 .313 0 .514.023-.067.536-.134 1.028-.201 1.564.67.09 1.318.18 1.967.291.067-.536.156-1.006.223-1.52.179.022.336.045.514.067a1447 1447 0 0 1-.536 3.733c-.045 0-.09.022-.112 0-.402-.045-.402-.045-.335-.47.067-.446.112-.916.179-1.385-.671-.09-1.32-.179-1.967-.268z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__l)",
    d: "M9.03 9.377c0 .245-.045.491-.045.737 0 .09.067.201.134.29.246.247.514.493.805.76-.157.157-.246.27-.38.403L6.884 8.84c.134-.134.246-.223.335-.335.425.425.872.827 1.319 1.274v-.224c0-.76 0-1.497.067-2.257 0-.224.246-.403.38-.626.045 0 .067.022.112.045-.023.693-.067 1.408-.09 2.145.917.157 1.81.291 2.727.448-.223.402-.38.491-.827.402a70 70 0 0 1-1.9-.358z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__m)",
    d: "M6.997 26.49c-.357.247-.693.448-.983.694-.246.2-.38.156-.492-.09 0-.044-.045-.067-.09-.134 1.029-.715 2.057-1.453 3.13-2.19.402.625.827 1.207 1.162 1.832.224.38.045.872-.313 1.163-.402.335-.871.424-1.251.156-.246-.178-.447-.402-.649-.648-.2-.223-.335-.492-.536-.782zm.358-.267s.067.089.09.134c.245.335.469.693.76.983.245.268.58.246.871 0 .29-.246.335-.492.112-.827a31 31 0 0 0-.604-.894c-.089-.157-.178-.134-.313-.045-.29.224-.603.425-.916.67z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__n)",
    d: "M24.274 30.143c.469-.224.469-.224.625.223.246.738.515 1.476.738 2.236.134.492-.045.916-.447 1.207-.402.29-.85.425-1.319.425-.536 0-.85-.313-1.05-.76-.224-.492-.38-1.006-.582-1.498-.111-.313-.223-.648-.357-.984.156-.067.313-.111.47-.2l.603 1.676c.09.245.179.514.29.76.246.514.649.67 1.185.469.604-.224.827-.581.648-1.14-.178-.581-.402-1.162-.58-1.721a8 8 0 0 0-.247-.67z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__o)",
    d: "M5.006 16.684h2.548c.022 0 .045 0 .134.022-.246.402-.47.805-.715 1.23.223.402.47.826.737 1.296-.447 0-.871.022-1.274 0-.178 0-.245.067-.313.179-.223.402-.447.782-.692 1.23-.269-.47-.537-.917-.805-1.387H3.173c.134-.246.246-.425.335-.626.09-.156.157-.29.246-.424.022-.045.134-.023.201-.045 0 .022.023.045.045.067-.09.224-.157.447-.268.715h2.302c.179-.29.38-.626.581-.983-.156-.246-.29-.537-.47-.783-.044-.067-.156-.156-.245-.156h-.805c-.09 0-.156-.09-.223-.112a.7.7 0 0 0 .111-.156zm.425 3.33c.156-.29.312-.536.447-.782h-.895c.157.268.291.492.448.782m1.72-3.017h-.826c.313.089.29.469.514.625.111-.2.2-.402.335-.625zm-.715 1.9h.738c-.134-.246-.268-.47-.38-.671-.112.224-.223.425-.335.67z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__p)",
    d: "m28.654 28.303-.269.403c-.067-.023-.134-.067-.2-.09-.47-.2-.873-.111-1.23.224-.358.335-.47.76-.335 1.207a2.33 2.33 0 0 0 1.005 1.252c.425.246.984.156 1.386-.201.358-.313.447-.76.268-1.252 0-.045-.044-.09-.067-.179.157-.067.313-.134.448-.201.312.626.268 1.207-.157 1.721-.693.827-1.632.983-2.481.313-.604-.47-1.028-1.05-.961-1.855.067-1.029 1.408-2.191 2.57-1.364z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__q)",
    d: "M29.974 24.581c.134.09.245.156.38.246-.224.357-.448.693-.694 1.073.94.603 1.856 1.207 2.795 1.833-.09.134-.18.268-.269.424-.938-.603-1.855-1.207-2.816-1.832-.224.357-.447.692-.67 1.05-.135-.067-.247-.156-.38-.246.558-.85 1.095-1.699 1.676-2.57z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__r)",
    d: "M5.002 16.705s-.09.112-.112.157c-.157.29-.335.558-.492.849-.067.112-.112.157-.223.067 0 0-.023-.045-.045-.067.112-.246.223-.514.335-.76a.17.17 0 0 1 .045-.09c.29-.514.603-1.005.939-1.564.268.447.514.872.76 1.296-.246.112-.38 0-.47-.2-.067-.157-.179-.314-.29-.515-.157.29-.29.559-.425.805z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__s)",
    d: "M4.112 17.74s.022.044.044.066c.18.358.38.693.582 1.05-.246.068-.38 0-.47-.2-.067-.157-.179-.291-.246-.425 0-.022-.022-.045-.044-.067-.269-.47-.515-.939-.805-1.453h1.23c.044 0 .066.112.111.179a.17.17 0 0 1-.045.09c-.246 0-.491.021-.76.044.157.268.29.492.425.715z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__t)",
    d: "M17.948 17.833c-.604.112-.805.358-.828.961-.022.76.18 1.43.626 2.124.18-.47.336-.917.492-1.342.179-.447.335-.916.537-1.363.067-.179.067-.313-.067-.47-.47-.558-.492-1.095-.112-1.587.111-.134.179-.2.357-.111.224.111.492.178.738.268.29.09.47.29.492.603v.94c-.045 0-.067.044-.09.022-.469-.045-.603.245-.715.625-.268.76-.559 1.498-.827 2.258l-.067.201c.715.313 1.095.224 1.475-.402.514-.827 1.029-1.677 1.565-2.526-.201-.09-.38-.179-.581-.268-.335-.157-.492-.403-.447-.76.044-.313.156-.604.268-.894 0-.045.179-.09.268-.067.268.067.514.178.783.268.447.156.58.358.603.872 0 .447-.09.871-.313 1.274a289 289 0 0 0-1.967 3.62c-.29.56-.648.716-1.274.65-.402-.046-.805 0-1.185 0-.313 0-.47-.113-.536-.403-.224-1.096-.447-2.168-.626-3.264-.045-.268 0-.58.067-.85.022-.2 0-.357-.134-.513-.425-.514-.402-1.05 0-1.565.045-.045.156-.09.223-.067.336.112.649.201.962.358.134.067.29.245.313.402.044.335 0 .693 0 1.05z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__u)",
    d: "M23.38 20.32c-.178-.67-.044-1.207.202-1.744.179-.402.29-.715-.023-1.14-.335-.424-.134-.983.358-1.475.179.335.47.358.805.358h1.587c.603 0 .916.2 1.14.76.313.737.357 1.52.335 2.324 0 .962-.179 1.9-.536 2.794-.18.448-.246.492-.716.492h-3.04c-.469 0-.514-.067-.424-.514.178-1.028.246-1.073 1.296-1.073.559 0 1.14 0 1.699-.045.514-.044.85-.357.894-.871a8.6 8.6 0 0 0 0-1.52c-.022-.447-.313-.671-.76-.671-.514 0-1.028.045-1.565.045a.37.37 0 0 0-.38.335c0 .201.112.313.313.358.604.156.961.871.76 1.497-.044.157-.268.224-.447.112a1.4 1.4 0 0 1-.335-.29c-.179-.202-.38-.18-.581-.045-.179.112-.38.201-.604.335z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__v)",
    d: "M13.993 17.837c-.603-.023-1.251-.045-1.9-.09-.357 0-.715-.044-1.072-.111-.38-.067-.582-.313-.56-.716 0-.29.09-.603.157-.916 1.252.29 2.481.246 3.71.246.358 0 .492.156.47.514-.022.425-.09.872-.112 1.296a32 32 0 0 0-.067 2.08c0 .58 0 1.162-.022 1.743-.022.514-.268.693-.805.693 0 0-.044-.045-.044-.067 0-1.073-.045-2.169 0-3.242 0-.469.156-.938.268-1.453z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Kosher_svg__w)",
    d: "M19.065 1.9c9.433 0 17.1 7.667 17.1 17.1s-7.667 17.1-17.1 17.1-17.1-7.667-17.1-17.1 7.667-17.1 17.1-17.1m0-1.9c-10.483 0-19 8.516-19 19s8.517 19 19 19 19-8.516 19-19-8.516-19-19-19"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__a",
    x1: 13.79,
    x2: 28.633,
    y1: 7.848,
    y2: 30.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__b",
    x1: 13.79,
    x2: 28.633,
    y1: 7.848,
    y2: 30.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__c",
    x1: 31.964,
    x2: 35.701,
    y1: 16.215,
    y2: 20.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__d",
    x1: 9.494,
    x2: 13.042,
    y1: 27.703,
    y2: 32.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__e",
    x1: 27.324,
    x2: 30.918,
    y1: 6.457,
    y2: 11.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__f",
    x1: 18.796,
    x2: 21.466,
    y1: 31.156,
    y2: 34.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__g",
    x1: 13.947,
    x2: 16.63,
    y1: 30.352,
    y2: 34.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__h",
    x1: 11.828,
    x2: 14.485,
    y1: 4.688,
    y2: 8.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__i",
    x1: 24.11,
    x2: 27.343,
    y1: 4.25,
    y2: 8.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__j",
    x1: 16.174,
    x2: 18.949,
    y1: 3.441,
    y2: 6.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__k",
    x1: 20.214,
    x2: 23.135,
    y1: 3.273,
    y2: 7.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__l",
    x1: 8.096,
    x2: 11.371,
    y1: 6.672,
    y2: 11.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__m",
    x1: 6.53,
    x2: 8.448,
    y1: 24.77,
    y2: 28.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__n",
    x1: 22.832,
    x2: 25.762,
    y1: 29.996,
    y2: 33.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__o",
    x1: 4.307,
    x2: 6.79,
    y1: 16.684,
    y2: 20.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__p",
    x1: 27.006,
    x2: 29.646,
    y1: 28,
    y2: 31.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__q",
    x1: 29.353,
    x2: 31.61,
    y1: 24.559,
    y2: 28.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__r",
    x1: 4.65,
    x2: 6.437,
    y1: 15.297,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__s",
    x1: 3.564,
    x2: 5.127,
    y1: 16.711,
    y2: 18.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__t",
    x1: 17.709,
    x2: 22.316,
    y1: 16.004,
    y2: 22.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__u",
    x1: 24.22,
    x2: 29.071,
    y1: 15.961,
    y2: 21.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__v",
    x1: 11.545,
    x2: 16.291,
    y1: 16.004,
    y2: 20.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Kosher_svg__w",
    x1: 9.565,
    x2: 34.899,
    y1: 0,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9846F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#EFD0B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B08271"
  })))));
};
export default SvgKosher;